function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacchinettaCaffe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C5D76"
    },
    d: "M443.733,443.733H68.267V193.422h375.467V443.733z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.933,
    y: 199.111,
    style: {
      fill: "#FF9811"
    },
    width: 34.133,
    height: 68.267
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9E3F7"
    },
    d: "M443.733,204.8H68.267V0h375.467V204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B9EB"
    },
    d: "M443.733,204.8H256V0h187.733V204.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136.533,
    y: 85.333,
    style: {
      fill: "#3C5D76"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.8,
    y: 85.333,
    style: {
      fill: "#3C5D76"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.067,
    y: 85.333,
    style: {
      fill: "#3C5D76"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.333,
    y: 85.333,
    style: {
      fill: "#3C5D76"
    },
    width: 34.133,
    height: 34.133
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M369.778,284.444c-5.984,0-11.726,1.041-17.067,2.935v-25.691H159.289v73.956 c0,53.327,43.385,96.711,96.711,96.711c37.779,0,70.546-21.786,86.454-53.444c7.913,5.015,17.282,7.933,27.324,7.933 c28.232,0,51.2-22.968,51.2-51.2C420.978,307.413,398.009,284.444,369.778,284.444z M369.778,352.711 c-9.411,0-17.067-7.656-17.067-17.067c0-9.411,7.656-17.067,17.067-17.067c9.411,0,17.067,7.656,17.067,17.067 C386.844,345.055,379.188,352.711,369.778,352.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F4FC"
    },
    d: "M369.778,284.444c-5.984,0-11.726,1.041-17.067,2.935v-25.691H256v170.667 c37.779,0,70.546-21.786,86.454-53.444c7.913,5.015,17.282,7.933,27.324,7.933c28.232,0,51.2-22.968,51.2-51.2 C420.978,307.413,398.009,284.444,369.778,284.444z M369.778,352.711c-9.411,0-17.067-7.656-17.067-17.067 c0-9.411,7.656-17.067,17.067-17.067c9.411,0,17.067,7.656,17.067,17.067C386.844,345.055,379.188,352.711,369.778,352.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9E3F7"
    },
    d: "M443.733,512H68.267v-85.333h375.467V512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B9EB"
    },
    d: "M443.733,512H256v-85.333h187.733V512z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacchinettaCaffe);
export default __webpack_public_path__ + "static/media/macchinetta_caffe.b4b4cd54d1208d54c471d0b4a280e55c.svg";
export { ForwardRef as ReactComponent };